import React from "react";

function ExperienceCard({ experience }) {
  return (
    <article className="flex flex-col rounded-lg items-center space-y-7 flex-shrink-0 w-[370px] md:w-[500px] xl:w-[900px] snap-center bg-[#292929] px-9 py-4 opacity-40 hover:opacity-100 transition-opacity duration-600 overflow-hidden cursor-pointer">
      <img
        src="https://images.unsplash.com/photo-1560179707-f14e90ef3623?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8Y29tcGFueSUyMGJ1aWxkaW5nfGVufDB8fDB8fA%3D%3D&amp;w=1000&amp;q=80"
        alt=""
        className="w-28 h-28 rounded-full xl:w-[150px] xl:h-[150px] object-cover object-center shrink-0"
        style={{ opacity: "1", transform: "none" }}
      />
      <div className="px-0 md:px-10">
        <h4 className="text-3xl md:text-4xl font-light">{experience.role}</h4>
        <p className="text-xl md:text-2xl font-bold mt-0 md:mt-1">
          {experience.companyName}
        </p>
        <p className="space-x-2 my-2 py-2 md:py-5 uppercase text-gray-300">
          {experience.duration}
        </p>
        <div className="space-y-4 ml-5 text-sm md:text-lg">
          {experience.information.map((info, index) => (
            <p key={index}>
              {index + 1}. {info}
            </p>
          ))}
        </div>
      </div>
    </article>
  );
}

export default ExperienceCard;
